import { Button, Card, Input, Modal, Table, message } from 'antd'
import React, { useState } from 'react'
import { useAddOrderNote, useOrderNote } from '../../../requests/order';
import { useParams } from "react-router-dom";
import moment from 'moment';

const OrderNotes = () => {


  const [isModal, setIsModal] = useState(false);
  const { id } = useParams();
  // add note
  const [note, setNote] = useState("");
  const { mutate, isLoading } = useAddOrderNote();
  const { data }  = useOrderNote(id);    
    const columns = [
      {
        title: 'Timestamp',
        dataIndex: '_date',
        key: '_date',
        render : _date => moment(_date).format('DD-MM-YYYY h:m A')
      },
      {
        title: 'Note',
        dataIndex: 'note',
        key: 'note',
      },
      {
        title: 'Added By',
        dataIndex: 'created_by',
        key: 'created_by',
      },
    ]

    console.log(data);


  return (
    <Card 
    title="Notes" 
    extra={[
        <Button 
          onClick={e=> {
            setIsModal(true);
          }} 
          
          size='small'>+
        </Button>
      ]}>
        <Table 
          pagination={false} 
          dataSource={data?.notes || []} 
          columns={columns} 
        />

        <Modal
          okText="Save"
          centered
          title="Order note"
          visible={isModal}
          okButtonProps={{ loading: isLoading }}
          onOk={() => {
            // setIsModal(true)
            if(!note){
              message.error('Write your note');
              return;
            }

            mutate({
              note,
              order_id: id
            }, {
              onSuccess:() => {
                // invalidate note list
                message.success('note added');
                setIsModal(false)
              },
              onError:err => {
                message.error(err?.message)
              }
            })

          
          }}
          onCancel={() => {
            setIsModal(false)
          }}
        >
          <Input.TextArea  
            value={note} 
            onChange={e => {
              setNote(e.target.value);
            }} 
          />
        </Modal>
    </Card>
  )
}

export default OrderNotes